import * as yup from "yup";

export const salaryPayroleSchema = yup.object().shape({
  password: yup
    .string()
    .min(6, "Password must be at least 6 characters")
    .required("Required"),
});
